import { render } from "./GitHubLogin.vue?vue&type=template&id=ed51a1de"
import script from "./GitHubLogin.vue?vue&type=script&lang=js"
export * from "./GitHubLogin.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Callum\\Desktop\\k1890584_watkins_callum_code\\mo-books\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__